export const defaultState = {
  year: '',
  newAdded: '',
  renewAdded: '',
  levelDomain: '',
};

export const updateFieldCreator = ({ name, value }) => ({
  type: 'updateField',
  payload: { name, value },
});

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'updateField':
      return { ...state, [action.payload.name]: action.payload.value };
    default:
      return state;
  }
};

export default reducer; 